<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <!-- Título y subtítulo -->
      <v-row justify="start" align="start" class="ma-0 mb-4 mt-5">
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: black;">
            Historial de cobros recibidos
          </div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            Aquí puedes revisar todos los cobros realizados por los clientes en sus líneas de crédito.
          </div>
        </v-col>
      </v-row>

      <!-- Buscador -->
      <v-row class="ma-0 mb-4" style="align-items: center;">
        <v-col cols="12" sm="4" md="3" class="pl-0">
          <v-text-field
            v-model="search"
            label="Buscar cobro"
            hide-details
            append-icon="mdi-magnify"
            outlined
            style="font-family: 'montserrat-medium'; border-radius: 20px; background-color: white;"
          />
        </v-col>
      </v-row>

      <!-- Tabla de contratos -->
      <v-data-table
        class="d-none d-sm-block"
        :items="filteredPayments"
        hide-default-header
      >
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">Cliente</th>
              <th class="header__title center">Monto total</th>
              <th class="header__title center">Monto intereses</th>
              <th class="header__title center">Monto a capital</th>
              <th class="header__title center">Fecha de pago</th>
              <th class="header__title right">Comprobante</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.enterprise_name }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.total_amount) + " " + item.currency }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.interest_paid) + " " + item.currency }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.principal_paid) + " " + item.currency }}</td>
              <td class="table__item">{{ formatDate(item.payment_date) }}</td>
              <td class="table__item center">
                <v-btn v-if="item.has_receipt" icon color="black" @click="viewReceipt(item)">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      search: "",
      isLoading: false,
      payments: []
    };
  },
  methods: {
    async viewReceipt(item) {
      try {
        const res = await DB.get(`${URI}/api/v1/en/admin/credit/credit_draw_payments/${item.id}/receipt`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ''
          }
        });
        window.open(res.data.url, '_blank');
      } catch (err) {
        this.$toast.error('Error al obtener el comprobante');
      }
    },
    async getPayments() {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/admin/credit/credit_draw_payments/payments`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.payments = response.data.payments;
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
  },
  computed: {
    filteredPayments() {
      if (!this.search) return this.payments;
      const filtro = this.search.toLowerCase();
      return this.payments.filter(item => {
        return (
          (item.enterprise_name || '').toLowerCase().includes(filtro) ||
          (item.currency || '').toLowerCase().includes(filtro) ||
          String(item.total_amount).includes(filtro) ||
          String(item.interest_paid).includes(filtro) ||
          String(item.principal_paid).includes(filtro) ||
          this.formatDate(item.payment_date).toLowerCase().includes(filtro)
        );
      });
    },
  },
  beforeMount() {
    this.getPayments();
  },
};
</script>

<style scoped>
.header__title {
  font-family: 'montserrat-semibold';
  font-size: 13px;
  padding: 12px;
}
.header__title.left {
  text-align: left;
}
.header__title.center {
  text-align: center;
}
</style>
